/* eslint-disable react/jsx-handler-names */

import { AddButton, Modal } from "@bluframe/blublocks"
import Button from "components/buttons/Button"
import ConfirmModal from "components/ConfirmModal"
import H4 from "components/Typography/H4"
import Paragraph from "components/Typography/Paragraph"

import { ComponentProps } from "."
import Item from "./Item"
import { ListAndAdd, ModalWrapper, Ul, Wrapper } from "./styled"

const ImageSelector = ({
  imagesAndIdentifiers,
  imageUrlRefs,
  mediaLabel,
  modal,
  onAddImage,
  onConfirm,
  onImageUrlChange,
  onSelectClick,
  onSelectImage,
  onSetImageAlternativeText,
  onSetImageCaption,
  onSetImageCredit,
  onRegenerateScreenshotMetadataField,
  showCreditInput,
  showScreenshotMetadataInputs,
  onUpdateSelectedImagePosition
}: ComponentProps) => (
  <>
    <Wrapper aria-label="Image Selector Controls" role="region">
      <Paragraph>
        {`${mediaLabel ?? "Images"}: ${imagesAndIdentifiers.length}`}
      </Paragraph>

      <Button label="Select" onClick={onSelectClick} />
    </Wrapper>

    <Modal {...modal}>
      <ConfirmModal
        message={
          <ModalWrapper>
            <H4>{mediaLabel ? `Select ${mediaLabel}` : "Select Images"}</H4>

            <ListAndAdd>
              <Ul aria-label="Image Selector Images">
                {imagesAndIdentifiers.map((image, index) => {
                  return (
                    <li
                      aria-label={`${image.identifier} Image`}
                      key={image.identifier}
                    >
                      <Item
                        image={image}
                        imageUrlRef={imageUrlRefs[index]}
                        isMultiSelect={false}
                        onArrowLeftClick={
                          index === 0
                            ? undefined
                            : onUpdateSelectedImagePosition("left")
                        }
                        onArrowRightClick={
                          index === imagesAndIdentifiers.length - 1
                            ? undefined
                            : onUpdateSelectedImagePosition("right")
                        }
                        onImageUrlChange={onImageUrlChange}
                        onRegenerateScreenshotMetadataField={
                          onRegenerateScreenshotMetadataField
                        }
                        onSelectImage={onSelectImage(image)}
                        onSetImageAlternativeText={onSetImageAlternativeText}
                        onSetImageCaption={onSetImageCaption}
                        onSetImageCredit={onSetImageCredit}
                        showCreditInput={showCreditInput}
                        showScreenshotMetadataInputs={
                          showScreenshotMetadataInputs
                        }
                      />
                    </li>
                  )
                })}
              </Ul>

              <AddButton
                label={mediaLabel ? `Add ${mediaLabel}` : "Add Image"}
                onClick={onAddImage}
              />
            </ListAndAdd>
          </ModalWrapper>
        }
        onClose={modal.onClose}
        onConfirm={onConfirm}
      />
    </Modal>
  </>
)

export default ImageSelector
